import { useIsLoggedIn } from '@order/AuthMachine';
import { useCustomer } from '@order/Customer';

// This ensures that calls to the backend will have a valid logged-in session.
export const useIsCustomerSessionReady = () => {
  const isLoggedIn = useIsLoggedIn();
  const customer = useCustomer();

  return Boolean(isLoggedIn && customer?.isCustomerLoaded);
};
